import validate from "/opt/portal/xyy-web/node_modules/.pnpm/nuxt@3.13.2_@parcel+watcher@2.4.1_@types+node@22.7.3_ioredis@5.4.1_magicast@0.3.5_rollup@4.22_cp5tigeaydejqm7rupsw4b2s4i/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45intercept_45components_45global from "/opt/portal/xyy-web/src/middleware/01.intercept-components.global.js";
import auth_45global from "/opt/portal/xyy-web/src/middleware/auth.global.js";
import car_45search_45global from "/opt/portal/xyy-web/src/middleware/car-search.global.js";
import create_45note_45global from "/opt/portal/xyy-web/src/middleware/create-note.global.js";
import manifest_45route_45rule from "/opt/portal/xyy-web/node_modules/.pnpm/nuxt@3.13.2_@parcel+watcher@2.4.1_@types+node@22.7.3_ioredis@5.4.1_magicast@0.3.5_rollup@4.22_cp5tigeaydejqm7rupsw4b2s4i/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _01_45intercept_45components_45global,
  auth_45global,
  car_45search_45global,
  create_45note_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}